export function clamp (value, min, max) {
  return Math.min(Math.max(value, min), max)
}
export function random (min, max, float = false) {
  if (!float) {
    return Math.floor(Math.random() * (max - min + 1)) + min
  } else {
    return (Math.random() * (max - min + 1)) + min
  }
}

export function shuffle (a) {
  for (let i = a.length; i; i--) {
    let j = Math.floor(Math.random() * i);
    [a[i - 1], a[j]] = [a[j], a[i - 1]]
  }
}

export function degToRad (angle) {
  return (angle * Math.PI / 180)
}

export function norm (X, MIN, MAX) {
  return (X - MIN) / (MAX - MIN)
}

export function map (X, MIN, MAX, A, B) {
  let norm = (X - MIN) / (MAX - MIN)
  return A + norm * (B - A)
}

export function round (value, decimal = 1e2) {
  return Math.round(value * decimal) / decimal
}

export function isInArray (array, search) {
  return array.indexOf(search) > -1
}



/** WEBPACK FOOTER **
 ** ./src/utils/math.js
 **/